// extracted by mini-css-extract-plugin
export default {"form":"styles_form__n2fXD","input":"styles_input__Iceyj","button":"styles_button__c55hU"};